import { Icon, IconWeight } from "@phosphor-icons/react";
import clsx from "clsx";

type IconSize = "default" | "large";

export type IconButtonProps = {
    type?: JSX.IntrinsicElements["button"]["type"];
    icon: Icon;
    iconSize?: IconSize;
    disabled?: boolean;
    onClick?: () => void;
    className?: string;
    value?: string;
    label: string;
    weight?: IconWeight;
};

const iconSizeMap: Record<IconSize, number> = {
    default: 20,
    large: 32,
};

const IconButton = ({
    type,
    disabled,
    icon: ButtonIcon,
    iconSize = "default",
    onClick,
    className,
    label,
    weight,
}: IconButtonProps) => {
    return (
        <button
            className={clsx(
                "h-[2.125rem] w-[2.125rem] flex items-center justify-center rounded-full hover:bg-surface-light-1 transition-colors flex-none",
                disabled && "opacity-40",
                className
            )}
            disabled={disabled}
            type={type}
            onClick={onClick}
        >
            <>
                <ButtonIcon size={iconSizeMap[iconSize]} weight={weight} />
                <span className="sr-only">{label}</span>
            </>
        </button>
    );
};

export default IconButton;
